import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon", "bg"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import Box from './Box';

function CircleOcticon(props) {
  var size = props.size,
      as = props.as;

  var IconComponent = props.icon,
      bg = props.bg,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Box, {
    as: as,
    bg: bg,
    overflow: "hidden",
    borderWidth: 0,
    size: size,
    borderRadius: "50%",
    borderStyle: "solid",
    borderColor: "border.default"
  }, /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex"
  }, rest, {
    alignItems: "center",
    justifyContent: "center"
  }), /*#__PURE__*/React.createElement(IconComponent, {
    size: size
  })));
}

CircleOcticon.displayName = "CircleOcticon";
CircleOcticon.defaultProps = _objectSpread(_objectSpread({}, Box.defaultProps), {}, {
  size: 32
});
export default CircleOcticon;